import { Select } from 'antd';
import { ShippingAccountTypeEnum } from 'domains/jobconfigDomain';
import { CarrierTypeEnum } from 'domains/shippingDomain';
import { useEffect, useState } from 'react';
import './TemporaryShippingUps.less';

export type TemporaryShippingUpsValue = {
  carrierType: CarrierTypeEnum;
  carrierService: string;
  accountType: ShippingAccountTypeEnum;
};

type Props = {
  value?: TemporaryShippingUpsValue;
  onChange?: (value: TemporaryShippingUpsValue) => void;
  carrierTypeList?: CarrierTypeEnum[];
  carrierServiceList?: string[];
  accountTypeList?: { name: string; value: ShippingAccountTypeEnum }[];
  upsTypePlaceholder?: string;
  upsServicePlaceholder?: string;
};

const { Option } = Select;

export const TemporaryShippingUps = ({
  carrierTypeList,
  carrierServiceList,
  accountTypeList,
  value,
  onChange,
  ...props
}: Props) => {
  const [curValue, setCurValue] = useState(value);
  useEffect(() => {
    // controlled mode
    if (value !== undefined) {
      setCurValue(value);
    }
  }, [value]);
  return (
    <div>
      <Select
        showSearch
        style={{ width: 200, marginBottom: 8 }}
        placeholder={props.upsTypePlaceholder}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
        }
        value={curValue?.carrierType}
        onChange={(val: CarrierTypeEnum) => {
          const newValue = {
            carrierType: val,
            carrierService: '',
            accountType: value?.accountType || ShippingAccountTypeEnum.REVSHOP,
          };

          if (value === undefined) {
            // uncontroled mode
            setCurValue(newValue);
          }
          if (onChange) {
            onChange(newValue);
          }
        }}
        getPopupContainer={(e) => {
          return e as HTMLElement;
        }}
      >
        {carrierTypeList?.map((item) => (
          <Option
            disabled={item !== CarrierTypeEnum.UPS}
            value={item}
            key={item}
          >
            {item}
          </Option>
        ))}
      </Select>

      <Select
        showSearch
        style={{ width: 200, marginBottom: 8 }}
        placeholder={props.upsServicePlaceholder}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
        }
        value={curValue?.carrierService}
        onChange={(val: string) => {
          if (curValue?.carrierType) {
            const newValue = {
              carrierType: curValue?.carrierType,
              carrierService: val,
              accountType:
                value?.accountType || ShippingAccountTypeEnum.REVSHOP,
            };
            if (value === undefined) {
              // uncontroled mode
              setCurValue(newValue);
            }
            if (onChange) {
              onChange(newValue);
            }
          }
        }}
        getPopupContainer={(e) => {
          return e as HTMLElement;
        }}
      >
        {carrierServiceList?.map((item) => (
          <Option value={item} key={item}>
            {item}
          </Option>
        ))}
      </Select>

      <Select
        showSearch
        style={{ width: 200, marginBottom: 8 }}
        placeholder={props.upsServicePlaceholder}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
        }
        value={curValue?.accountType}
        onChange={(val: ShippingAccountTypeEnum) => {
          if (curValue?.carrierType) {
            const newValue = {
              carrierType: curValue?.carrierType,
              carrierService: curValue?.carrierService,
              accountType: val,
            };
            if (value === undefined) {
              // uncontroled mode
              setCurValue(newValue);
            }
            if (onChange) {
              onChange(newValue);
            }
          }
        }}
        getPopupContainer={(e) => {
          return e as HTMLElement;
        }}
      >
        {accountTypeList?.map((item) => (
          <Option value={item.value} key={item.value}>
            {item.name}
          </Option>
        ))}
      </Select>
    </div>
  );
};
